/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Not_EditableInputs */

const vi_api_keys_not_editable = /** @type {(inputs: Api_Keys_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoá đã thu hồi hoặc không phải khoá đối tác nên không sửa quyền được.`)
};

/**

* @param {Api_Keys_Not_EditableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_not_editable = /** @type {((inputs?: Api_Keys_Not_EditableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Not_EditableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_not_editable(inputs)
});